(() => {
	const body = document.body;
	const scrollOffset = 1;
	let ticking = false;
	let isScrolled = null;

	function applyState() {
		const next = (window.scrollY || 0) > scrollOffset;

		if (next !== isScrolled) {
			body.classList.toggle('scrolled', next);
			isScrolled = next;
		}

		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(applyState);
			ticking = true;
		}
	}

	applyState();
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('pageshow', applyState);
	window.addEventListener('load', applyState, { once: true });
})();
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('img[title]').forEach(img => {
		const title = img.getAttribute('title');

		img.addEventListener('mouseenter', () => img.removeAttribute('title'));
		img.addEventListener('mouseleave', () => img.setAttribute('title', title));
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const cards = document.querySelectorAll('main .three-images-with-text > div');

	cards.forEach((card) => {
		const link = card.querySelector('a[href]:not([href^="mailto:"]):not([href^="tel:"])');
		if (!link) {return;}

		// ----------------------------
		// ARIA-LABEL
		// ----------------------------
		const ariaLabel =
			link.getAttribute('aria-label') ||
			link.getAttribute('title') ||
			link.textContent.trim() ||
			'Link';

		// A11y
		card.setAttribute('aria-label', ariaLabel);
		card.classList.add('clickable-card');

		// ----------------------------
		// Maus / Touch
		// ----------------------------
		card.addEventListener('click', (e) => {
			// real interactive elements should behave normally.
			if (e.target.closest('a, button, input, textarea, select')) {return;}
			link.click();
		});

		// ----------------------------
		// Keyboard (A11y)
		// ----------------------------
		card.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				link.click();
			}
		});
	});
});

